import { useToastAPI } from '@moneyforward/ap-frontend-components';
import { useEffect } from 'react';
import {
  PAYEE_LIST_ERROR_TOAST_MESSAGE_KEY,
  PAYEE_LIST_SUCCESS_TOAST_MESSAGE_KEY,
} from '../constants';

type ToastConfig = {
  key: string;
  type: 'error' | 'success';
  duration: number;
};

const TOAST_CONFIGS: ToastConfig[] = [
  {
    key: PAYEE_LIST_ERROR_TOAST_MESSAGE_KEY,
    type: 'error',
    duration: 5,
  },
  {
    key: PAYEE_LIST_SUCCESS_TOAST_MESSAGE_KEY,
    type: 'success',
    duration: 5,
  },
];

export const usePayeeListToast = () => {
  const notify = useToastAPI();

  useEffect(() => {
    TOAST_CONFIGS.forEach(({ key, type, duration }) => {
      const message = sessionStorage.getItem(key);
      if (!message) return;

      notify[type]({
        title: message,
        duration,
      });
      sessionStorage.removeItem(key);
    });
  }, [notify]);
};
